import { render, staticRenderFns } from "./CandidateLogins.vue?vue&type=template&id=13b23b39&scoped=true"
import script from "./CandidateLogins.vue?vue&type=script&lang=js"
export * from "./CandidateLogins.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b23b39",
  null
  
)

export default component.exports